import request from '@shared/api/request';
import { API_SCHEMES_PATH, API_STANDS_PATH } from '@shared/constants/pathsConstants';
import { getBookingDevices } from '@pages/booking/api';

export function getSchemes(params) {
    return request.get(`/${API_SCHEMES_PATH}/`, {
        params: {
            ...params,
            page_index: params?.page_index + 1,
        },
    });
}

export function getAllSchemes(module) {
    return request.get(`/${API_SCHEMES_PATH}/`, {
        params: { module },
    });
}
export function getSchemeById(id) {
    return request.get(`/${API_SCHEMES_PATH}/${id}/`);
}

export function addScheme(scheme) {
    return request.post(`/${API_SCHEMES_PATH}/`, scheme);
}

export async function fetchSchemePreview(previewUrl) {
    const res = await fetch(previewUrl);
    return await res.blob();
}

export function editScheme(id, scheme) {
    const { preview, ...otherSchemeData } = scheme;
    return request.patch(`/${API_SCHEMES_PATH}/${id}/`, otherSchemeData);
}

export function editSchemePreview(id, preview) {
    let payload = new FormData();
    payload.append('preview', preview);
    return request.patch(`/${API_SCHEMES_PATH}/${id}/`, payload);
}

export function deleteScheme(id) {
    return request.delete(`/${API_SCHEMES_PATH}/${id}/`);
}

export function getTrexStatus({ standId, nodeName }) {
    return request.get(`/${API_STANDS_PATH}/${standId}/${nodeName}/status`);
}

export function startTrex({ standId, nodeName }) {
    return request.post(`/${API_STANDS_PATH}/${standId}/${nodeName}/start`);
}

export function stopTrex({ standId, nodeName }) {
    return request.post(`/${API_STANDS_PATH}/${standId}/${nodeName}/stop`);
}

export function getBookingDevicesForScheme(schemeId) {
    return getBookingDevices({ schemeId });
}

export function getBookingDevicesAvailableForSchemes() {
    return getBookingDevices({});
}

export function getBookingDevicesRequiredForScheme(id) {
    return request.get(`/${API_SCHEMES_PATH}/${id}/hardware/`);
}
